import React, { forwardRef } from 'react';

import { Icon } from '../icon';

export const PopupWraper = forwardRef<
  HTMLDivElement,
  {
    title: string;
    onClose: () => void;
    center?: boolean;
    children?: any;
    style?: React.CSSProperties;
    className?: string;
  }
>(function PopupWraper(props, ref) {
  const id = `${Date.now()}-popupwraper`;

  return (
    <div
      id={id}
      ref={ref}
      className={['PopupWraper', props.className].filter(Boolean).join(' ')}
      role='dialog'
      aria-modal='true'
      aria-label={props.title}
      onClick={(e: any) => (e.target.id === id ? props.onClose() : null)}
    >
      <div className='box' style={props.style}>
        <div className='boxTitle'>
          <span>{props?.title}</span>
          <button
            type='button'
            className='btnClose'
            aria-label='Đóng'
            style={{ padding: 0, border: 0, background: 'transparent' }}
            onClick={() => props.onClose()}
          >
            <Icon.Close />
          </button>
        </div>
        <div className='content'>{props.children}</div>
      </div>
    </div>
  );
});
